import { render, staticRenderFns } from "./ObjectAccessHelp.vue?vue&type=template&id=0a7372fa&scoped=true&"
import script from "./ObjectAccessHelp.vue?vue&type=script&lang=js&"
export * from "./ObjectAccessHelp.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAccessHelp.vue?vue&type=style&index=0&id=0a7372fa&scoped=true&lang=css&"
import style1 from "./ObjectAccessHelp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7372fa",
  null
  
)

export default component.exports